<template>
  <div class="modal modal-open">
    <div class="modal-background" @click.prevent="emitToParent" ></div>
    <div v-if="title" class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
        <button class="delete" @click.prevent="emitToParent" aria-label="close"></button>
      </header>
      <section class="modal-card-body">
        <slot></slot>
      </section>
      <footer class="modal-card-foot">
        {{ footer }}
      </footer>
    </div>
    <div v-if="!title" class="modal-content">
      <button class="delete" :class="{ 'is-large' : largeCloseBtn  } " @click.prevent="emitToParent" aria-label="close"></button>
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String
    },
    largeCloseBtn: {
      type: Boolean
    },
    footer: {
      type: String
    }
  },
  data () {
    return {
      
    }
  },
  watch: {

  },
  computed: {
    
  },
  methods: {
    emitToParent (event) {
      this.$emit('childToParent', true)
    }
  },
}
</script>

<style scoped lang="scss">
.content {
  ul.ticks {
    margin-left:0;

    li {
      border-top:1px solid $light-grey;
      margin:0;
      padding:0.6rem 0 0.6rem 2.5rem;

      line-height:1rem;

      &:first-child {
        border-top:none;
      }

      svg {
        left:0.5rem;
        top:0.6rem;
      }
    }
  }
}
</style>